<div class="fx-ai-center fx-jc-center"
     [class]="hiddenClass">
  <div class="element-1 mdc-card mdc-elevation--z2 signin-card">
    <a class="signin-logo"
       href="/">
      <img class="element-3"
           alt
           src="../../assets/Nuage-Logo.png">
    </a>
    <form class="signin-form"
          autocomplete="off">
      <!-- Email Text Field -->
      <mat-form-field *ngIf="!twofacode_needed"
                      class="element-5"
                      color="warn">
        <mat-label>Email</mat-label>
        <mat-icon matPrefix>mail</mat-icon>
        <input #emailInput

               autocomplete="new-email-input"
               autofocus
               name="email-input"
               placeholder="name@nuage.clinic"
               type="email"
               matInput

               [formControl]="email"
               (input)="handleChange()">
        <mat-error *ngIf="email.invalid">
          {{ getErrorMessage(email) }}
        </mat-error>
      </mat-form-field>
      <!-- Password Text Field -->
      <mat-form-field *ngIf="!twofacode_needed"
                      class="element-4"
                      color="warn">
        <mat-label>Password</mat-label>
        <mat-icon matPrefix>lock</mat-icon>
        <input #passwordInput

               autocomplete="off"
               name="password-input"
               placeholder="Enter your password"
               type="text"
               matInput

               [class.password-input]="hide"
               [formControl]="password"

               (input)="handleChange()"
               (keydown.enter)="login($event)">
        <mat-error *ngIf="password.invalid">
          {{ getErrorMessage(password) }}
        </mat-error>
        <button type="button"

                mat-icon-button
                matSuffix

                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hide"
                (click)="hide = !hide">
          <mat-icon>
            {{ hide ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </button>
      </mat-form-field>
      <!-- Submission Button -->
      <button *ngIf="!twofacode_needed"

              class="sign-in-button"
              color="warn"
              name="sign-in-button"
              type="button"
              mat-flat-button

              [disabled]="!email.valid || !password.valid || isLoggingIn"
              (click)="signIn()">
        {{ isLoggingIn ? 'Signing in...' : 'LOGIN' }}
      </button>
      <div *ngIf="errorMessage"
           class="error-message-container">
        <mat-icon class="error-icon">
          error_outline
        </mat-icon>
        <span class="error-text">
          {{errorMessage}}
        </span>
      </div>
      <!-- Forgot your password / Back to home -->
      <div class="signin-footer-links">
        <a class="fgpass-text-dec"
           (click)="navigateToFGPass()">
          Reset your password
        </a>
        <a class="backtohome-link"
           (click)="backToHome()">
          ← Back to home
        </a>
      </div>
    </form>
  </div>
</div>
